import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import App from '../components/App';
import { languageTypes } from '../config/constants';

const Routes = () => {
  const languageURL = languageTypes.en
  return (
    <Route path="/">
      <Route exact path="/">
        <Redirect to={`/${languageURL}/`} />
      </Route>
      <Route path="/:locale">
        <App />
      </Route>
    </Route>
  );
};

export default Routes;
